export default __webpack_public_path__ + "2bfcf73.png";